var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 460,
    height: 512,
    viewBox: "0 0 460 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28_456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M382.4 412.6C393.4 412.6 402.4 403.6 402.4 392.6V20C402.4 9 393.4 0 382.4 0C371.4 0 362.4 9 362.4 20V392.6C362.4 403.6 371.4 412.6 382.4 412.6ZM77.7 412.6C88.7 412.6 97.7 403.6 97.7 392.6V256C97.7 245 88.7 236 77.7 236C66.7 236 57.7 245 57.7 256V392.6C57.7 403.6 66.7 412.6 77.7 412.6ZM229.1 412.6C240.1 412.6 249.1 403.6 249.1 392.6V133.9C249.1 122.9 240.1 113.9 229.1 113.9C218.1 113.9 209.1 122.9 209.1 133.9V392.5C209.1 403.5 218.1 412.5 229.1 412.5V412.6ZM439.1 472H20C9 472 0 481 0 492C0 503 9 512 20 512H439.1C450.1 512 459.1 503 459.1 492C459.1 481 450.1 472 439.1 472Z",
    fill: "#1F1F1F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28_456"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 459.1,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.6e9389bfe0ca0f4a79a3b298064ec77d.svg";
export { ForwardRef as ReactComponent };